import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PopupComponent } from '@app/components/popup/popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DeviceTypeService } from '@services/device-type.service';

@Component({
  selector: 'app-connector-card',
  templateUrl: './connector-card.component.html',
  styleUrls: ['./connector-card.component.scss'],
  standalone: false,
})
export class ConnectorCardComponent implements OnInit {
  @Input() connector!: any;
  @Input() connectorIndex!: number;
  @Input() processing: boolean = false;
  @Input() isListView: boolean = false;
  @Input() onboarding: boolean = false;
  @Input() showWorkspaceActive: boolean = false;
  @Input() showConnectorButton = true;
  @Input() showConnectorWeight = false;
  @Input() isWorkspaceConnector = false;
  @Input() connectorUpdatedUuid!: string | null;
  @Output() onGoToLogin = new EventEmitter<void>();
  @Output() onLogoutConnector = new EventEmitter<void>();
  @Output() onToggleSwitch = new EventEmitter<void>();
  @Output() onToggleSwitchSubconnector = new EventEmitter<any>();
  @Output() onEditWorkspaceConnector = new EventEmitter<any>();
  @Output() onDeleteWorkspaceConnector = new EventEmitter<any>();
  @Output() onToggleWorkspaceConnectorStatus = new EventEmitter<any>();
  @Output() onInitAnimationSubconnectorsList = new EventEmitter<any>();
  @Output() onFinishAnimationSubconnectorsList = new EventEmitter<any>();
  @Output() onDuplicateWorkspaceConnector = new EventEmitter<any>();
  @ViewChild('connectedCard', { static: false }) connectedCard!: ElementRef;
  @ViewChild('loginCard', { static: false }) loginCard!: ElementRef;
  @ViewChild('listTypeCard', { static: false }) listTypeCard!: ElementRef;
  @ViewChild('workspaceCard', { static: false }) workspaceCard!: ElementRef;

  isCollapsed = true;
  public onlyActiveSubconnectorList: any = [];

  constructor(
    @Inject(NgbModal) private modalService: NgbModal,
    public _translateService: TranslateService,
    public deviceType: DeviceTypeService,
  ) {}

  ngOnInit(): void {
    this.onlyActiveSubconnectorList = this.connector.subconnectors.filter((e: any) => e.status === 'active');
    // this.isCollapsed = !this.connector.is_logged_in; // Inverteix el valor si l'usuari està identificat
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  goToLogin() {
    this.onGoToLogin.emit();
  }

  logoutConnector() {
    this.onLogoutConnector.emit();
  }

  activeAnimationSubconnectorList() {
    this.onInitAnimationSubconnectorsList.emit();
  }

  finishAnimationSubconnectorList() {
    this.onFinishAnimationSubconnectorsList.emit();
  }

  connectClick(connector: any, isSubConnector: boolean = false) {
    isSubConnector ? this.onToggleSwitchSubconnector.emit(connector) : this.onToggleSwitch.emit();
    connector.is_enabled = true;
  }

  disconnectClick(connector: any, isSubConnector: boolean = false) {
    isSubConnector ? this.onToggleSwitchSubconnector.emit(connector) : this.onToggleSwitch.emit();
    connector.is_enabled = false;
  }

  openInfoModal(connector: any) {
    let rect: any;
    if (this.isWorkspaceConnector) {
      rect = this.workspaceCard.nativeElement.getBoundingClientRect();
    } else {
      if (this.isListView) {
        rect = this.listTypeCard.nativeElement.getBoundingClientRect();
      } else {
        if (connector.is_logged_in) rect = this.connectedCard.nativeElement.getBoundingClientRect();
        else rect = this.loginCard.nativeElement.getBoundingClientRect();
      }
    }
    let customPosition = { top: rect.top - 25, left: rect.left };
    let modalWidth = 385;
    if (this.isListView) {
      customPosition = { top: rect.top - 25, left: rect.right - modalWidth };
    }
    if (this.isWorkspaceConnector) {
      customPosition = { top: rect.top - 40, left: rect.right - modalWidth };
    }

    const modalRef = this.modalService.open(PopupComponent, {
      backdrop: 'static',
      size: 'sm',
      windowClass: !this.deviceType.isDesktop ? 'med_alert-modal-app-info' : 'med_alert-modal-component', // Do NOT change this class, it is used on styles.scss
      animation: false,
      centered: !this.deviceType.isDesktop,
    });
    if (this.deviceType.isDesktop) {
      modalRef.componentInstance.topPosition = customPosition.top;
      modalRef.componentInstance.leftPosition = customPosition.left;
      modalRef.componentInstance.modalWidth = modalWidth;
    } else {
      modalRef.componentInstance.modalWidth = '100%';
    }
    let messageAlert = connector.connector.description || connector.connection_parameters.description;
    modalRef.componentInstance.title = connector.name;
    modalRef.componentInstance.messageAlert = messageAlert;
    this._translateService.get('close').subscribe((t) => (modalRef.componentInstance.closeText = t));
  }

  openDisconnectModal(connector: any) {
    let rect: any;
    if (this.isListView) {
      rect = this.listTypeCard.nativeElement.getBoundingClientRect();
    } else {
      if (connector.is_logged_in) rect = this.connectedCard.nativeElement.getBoundingClientRect();
      else rect = this.loginCard.nativeElement.getBoundingClientRect();
    }
    let customPosition = { top: rect.top - 25, left: rect.left };
    let modalWidth = 385;
    if (this.isListView) {
      customPosition = { top: rect.top - 25, left: rect.right - modalWidth };
    }

    const modalRef = this.modalService.open(PopupComponent, {
      backdrop: 'static',
      size: 'sm',
      windowClass: !this.deviceType.isDesktop ? 'med_alert-modal-app-info' : 'med_alert-modal-component', // Do NOT change this class, it is used on styles.scss
      animation: false,
      centered: !this.deviceType.isDesktop,
    });
    if (this.deviceType.isDesktop) {
      modalRef.componentInstance.topPosition = customPosition.top;
      modalRef.componentInstance.leftPosition = customPosition.left;
      modalRef.componentInstance.modalWidth = modalWidth;
    } else {
      modalRef.componentInstance.modalWidth = '100%';
    }
    this._translateService
      .get(['are_you_sure_short', 'disconnect_confirmation', 'cancel', 'disconnect'])
      .subscribe((t) => {
        modalRef.componentInstance.title = t['are_you_sure_short'];
        const msg = `${t['disconnect_confirmation']} ${connector.parentUuid ? connector.parent.name : connector.name}`;
        modalRef.componentInstance.messageAlert = msg;
        modalRef.componentInstance.closeText = t['cancel'];
        modalRef.componentInstance.actionText = t['disconnect'];
      });
    modalRef.componentInstance.showActionBtn = true;
    modalRef.result
      .then((resp: any) => {
        if (resp == 'doAction') this.logoutConnector();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  calculateDots(weight: number): number {
    return weight;
  }

  isOverflowText(idElement: string): boolean {
    const element = document.getElementById(idElement);
    if (element && element.scrollWidth > element.clientWidth) {
      return true;
    }
    return false;
  }

  editWorkspaceConnector(connector: any) {
    this.onEditWorkspaceConnector.emit(connector);
  }

  deleteWorkspaceConnector(connector: any) {
    this.onDeleteWorkspaceConnector.emit(connector);
  }

  toggleWorkspaceConnectorStatus(connector: any) {
    this.onToggleWorkspaceConnectorStatus.emit(connector);
  }

  duplicateConnector(connector: any) {
    this.onDuplicateWorkspaceConnector.emit(connector);
  }
}
